import { forwardRef } from 'react';

import { Icon, IconProps } from '@/component-library/Icon';

const DOT = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon {...props} ref={ref} viewBox='0 0 45 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>DOT</title>
    <rect x='.5' y='.5' width='44' height='44' rx='22' fill='#000' />
    <g clipPath='url(#a)' fill='#E6007A'>
      <path d='M22.499 15.244c2.648 0 4.794-1.174 4.794-2.622S25.147 10 22.5 10c-2.648 0-4.794 1.174-4.794 2.622s2.146 2.622 4.794 2.622ZM22.499 34.998c2.648 0 4.794-1.174 4.794-2.622 0-1.447-2.146-2.621-4.794-2.621-2.648 0-4.794 1.174-4.794 2.621 0 1.448 2.146 2.622 4.794 2.622ZM15.818 18.873c1.324-2.156 1.315-4.491-.02-5.216-1.334-.724-3.489.436-4.812 2.592-1.324 2.156-1.316 4.491.019 5.216 1.334.724 3.49-.436 4.813-2.592ZM34.01 28.749c1.324-2.156 1.316-4.49-.017-5.215-1.334-.724-3.488.437-4.812 2.593-1.324 2.156-1.316 4.49.018 5.215 1.333.724 3.488-.437 4.811-2.593ZM15.8 31.341c1.334-.724 1.343-3.06.019-5.215-1.324-2.156-3.48-3.317-4.814-2.592-1.334.724-1.343 3.06-.019 5.215 1.324 2.156 3.48 3.317 4.814 2.592ZM33.994 21.465c1.334-.724 1.342-3.058.018-5.214-1.324-2.156-3.479-3.317-4.812-2.593-1.334.724-1.341 3.058-.018 5.214 1.324 2.157 3.479 3.317 4.812 2.593Z' />
    </g>
    <rect x='.5' y='.5' width='44' height='44' rx='22' stroke='#fff' />
    <defs>
      <clipPath id='a'>
        <path fill='#fff' transform='translate(10 10)' d='M0 0h25v25H0z' />
      </clipPath>
    </defs>
  </Icon>
));

DOT.displayName = 'DOT';

export { DOT };
